import React, { createContext, useContext, useState } from 'react';

interface ZonaHoraria {
    zona: string;
    gmt: number;
    areaServicio: number;
}

interface ZonaHorariaContextProps {
    zonaHoraria: ZonaHoraria;
    setZonaHoraria: React.Dispatch<React.SetStateAction<ZonaHoraria>>;
    fechaServidor: Date | null;
    setFechaServidor: React.Dispatch<React.SetStateAction<Date | null>>;
}


const ZonaHorariaContext = createContext<ZonaHorariaContextProps | undefined>(undefined);

export const ZonaHorariaProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [zonaHoraria, setZonaHoraria] = useState<ZonaHoraria>({ zona: '', gmt: 0 , areaServicio: 0 });
    const [fechaServidor, setFechaServidor] = useState<Date | null>(null);

    return (
        <ZonaHorariaContext.Provider value={{ zonaHoraria, setZonaHoraria,
            fechaServidor, setFechaServidor 
         }}>
            {children}
        </ZonaHorariaContext.Provider>
    );
};

// Hook
export const useZonaHoraria = () => {
    const context = useContext(ZonaHorariaContext);
    if (!context) {
        throw new Error("useZonaHoraria debe ser usado dentro de un ZonaHorariaProvider");
    }
    return context;
};
